const REPAIR_TYPE = {
	NOT_REPAIRED: {
		code: 0,
		label: "common.typeList.repairType.notRepaired"
	},
	REPAIRED: {
		code: 1,
		label: "common.typeList.repairType.repaired"
	}
}

export default REPAIR_TYPE
